module.exports = __webpack_public_path__ + "img/msg.b32458e0.png";